import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';

import LinkBuilder from 'helpers/link-builder';
import { DateHelpers } from 'helpers/date-helpers';
import LinkCandidateProfile from 'components/LinkCandidateProfile';

const TypeCandidateAddedReference = props => {
  const {
    user,
    post: {
      CandidateID,
      FullName,
      FirmName,
      FirmActive,
      FirmUrlAlias,
      currentSchoolName,
      NewsFeedDateAdd,
      Date,
      ViewProfile,
      ViewAsRecruiter,
    },
  } = props;

  const firmLink = FirmUrlAlias ? (
    FirmActive === 'Yes' ? (
      <NavLink to={LinkBuilder.getFirmLink(FirmUrlAlias)}>{FirmName}</NavLink>
    ) : (
      <span className="feed-post-content__span">{FirmName}</span>
    )
  ) : (
    currentSchoolName && (
      <span className="feed-post-content__span">{currentSchoolName}</span>
    )
  );

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        <LinkCandidateProfile
          cls="feed-post-content__profile-name"
          clsSpan="feed-post-content__hero"
          styleSpan={{ marginRight: '0.5em' }}
          user={user}
          id={CandidateID}
          name={FullName}
          viewProfile={ViewProfile === 'Yes'}
          viewAsRecruiter={ViewAsRecruiter === 'Yes'}
        />
        <div className="feed-post-content__text">from</div>
        {firmLink}
        <div className="feed-post-content__text">added a reference</div>
      </div>
      <div className="feed-post-content__date">{date}</div>
    </div>
  );
};

export default TypeCandidateAddedReference;
